import { gql } from '@apollo/client';
import FolderProductSettings from "../fragments/FolderProductSettings";

const getProductionSettingsForSite = gql`
  query getProductionSettingsForSite($siteId: Int!) {
    addFilesToCart {
      getProductionSettingsForSite(siteId: $siteId) {
        folderId
        folderProductSettings {
          ...FolderProductSettingsFragment
        }
      }
    }
  }
  ${FolderProductSettings}
`;

export default getProductionSettingsForSite;
